import React from 'react';
import './style.css'
import AddDiagnosticModal from './components/add-diagnostic/index';
import diagnostics from '../../../../services/diagnostics/index';
import ConfirmComponent from '../../../../components/confirm/index';
import DropdownComponent from '../../../../components/dropdown/index';

export default class DiagnosticsComponent extends React.Component {
    state = {
        diagnostics: [],
        display: [],
        modal: "",
        diagnostic: null,
        status: "activo"
    }

    filterMenu = [
        {
            text: "Activos",
            onClick: () => this.filterDisplay("activo")
        },
        {
            divider: true
        },
        {
            text: "Inactivos",
            onClick: () => this.filterDisplay("inactivo")
        }
    ]

    componentWillMount() {
        diagnostics.find({}, (err, diagnostics) => {
            let display = diagnostics.filter(diagnostic => diagnostic.status === "activo")
            this.setState({diagnostics: diagnostics, display: display})
        })
    }

    filterDisplay = (status) => {
        let display = this.state.diagnostics.filter(diagnostic => diagnostic.status === status)
        this.setState({display: display, status: status})
    }

    addDiagnostic = (diagnostic) => {
        if(this.state.status == "activo") 
            this.setState({
                diagnostics: this.state.diagnostics.concat(diagnostic),
                display: this.state.display.concat(diagnostic),
                modal: "",
                diagnostic: null
            })
        else
            this.setState({
                diagnostics: this.state.diagnostics.concat(diagnostic),
                modal: "",
                diagnostic: null
            })
    }

    removeDiagnostic = () => {
        diagnostics.update({_id: this.state.diagnostic._id}, { $set: {status: "inactivo"} }, (err, diagnostic) => {
            let diagnostics = Object.assign([],this.state.diagnostics);
            let index = diagnostics.findIndex(diag => diag._id === this.state.diagnostic._id);
            let display = Object.assign([],this.state.display)
            let index2 = display.findIndex(diag => diag._id === this.state.diagnostic._id)
            if(index !== -1 && index2 != -1) {
                diagnostics[index].status = "inactivo";
                display.splice(index2, 1);
                this.setState({diagnostics: diagnostics,display: display, diagnostic: null})
            }
        })
    }

    restaureDiagnostic = () => {
        diagnostics.update({_id: this.state.diagnostic._id}, { $set: {status: "activo"} }, (err, diagnostic) => {
            let diagnostics = Object.assign([],this.state.diagnostics);
            let index = diagnostics.findIndex(diag => diag._id === this.state.diagnostic._id);
            let display = Object.assign([],this.state.display)
            let index2 = display.findIndex(diag => diag._id === this.state.diagnostic._id)
            if(index !== -1 && index2 != -1) {
                diagnostics[index].status = "activo";
                display.splice(index2, 1);
                this.setState({diagnostics: diagnostics,display: display, diagnostic: null})
            }
        })
    }

    get confirmText() {
        if(this.state.diagnostic)
            return `¿Está seguro de que desea desactivar el servicio ${this.state.diagnostic.name}?`
        else
            return ""
    }

    get restaureText() {
        if(this.state.diagnostic)
            return `¿Está seguro de que desea activar el servicio ${this.state.diagnostic.name}?`
        else
            return ""
    }

    openModal = (modal, diagnostic = null) => this.setState({modal: modal, diagnostic: diagnostic})
    closeModal = () => this.setState({modal: "", diagnostic: null})

    renderRow = (diagnostic, index) => {
        return (
            <tr key={index}>
                <td>{diagnostic.name}</td>
                <td>
                    {diagnostic.status == "activo" ?
                    <button onClick={() => this.openModal("delete", diagnostic)} className="delete-button">
                        <i className="fas fa-times"></i>
                    </button> :
                    <button onClick={() => this.openModal("restaure", diagnostic)} className="restaure-button">
                        <i className="fas fa-undo-alt"></i>
                    </button> }
                </td>
            </tr>
        );
    }

    render() {
        return (
            <React.Fragment>
                <div className="Diagnostics">
                    <div className="card">
                        <header className="card-header">
                            <h2 className="card-header-title">Servicios</h2>
                            <div style={{padding: 0}} className="card-header-icon header-button">
                                <DropdownComponent menu={this.filterMenu}
                                    title={<i className="fas fa-filter hover-color" aria-hidden="true"></i>}
                                    color="#449c8c" />
                            </div>
                            <a className="card-header-icon header-button"
                                onClick={() => this.openModal("add")}>
                                <span className="icon">
                                    <i className="fas fa-plus" aria-hidden="true"></i>
                                </span>
                            </a>
                        </header>
                        <div className="card-content">
                            {this.state.display.length > 0 ?
                            <table className="table is-fullwidth">
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.display.map(this.renderRow)}
                                </tbody>
                            </table> :
                            <p>No hay servicios....</p>}
                        </div>
                    </div>
                </div>
                <AddDiagnosticModal isActive={this.state.modal == "add"}
                    add={this.addDiagnostic}
                    close={this.closeModal}
                />
                <ConfirmComponent header="Restaurar"
                    close={this.closeModal}
                    isActive={this.state.modal === "restaure"}
                    text={this.restaureText}
                    onSubmit={this.restaureDiagnostic}
                />
                <ConfirmComponent header="Eliminar"
                    close={this.closeModal}
                    isActive={this.state.modal === "delete"}
                    text={this.confirmText}
                    onSubmit={this.removeDiagnostic}
                />
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/diagnostics/index.js